export default __webpack_public_path__ + "static/media/7707BLEU.003aa777.pdf";